import { forwardRef, FormHTMLAttributes } from 'react';
import { Form, FormikFormProps } from 'formik';

import { useSyncFeatureFlag } from '@/hooks/utils/useFeatureFlags';
import { FeatureNames } from '@/types/features';

type Props = FormikFormProps & FormHTMLAttributes<HTMLFormElement>;

const FormComponent = forwardRef<HTMLFormElement, Props>(
  ({ method = 'POST', children, ...props }, ref) => {
    const formMethodUpdateEnabled = useSyncFeatureFlag(
      FeatureNames.FormMethodUpdate
    );

    const formProps: Props = {
      ...props,
      ...(formMethodUpdateEnabled && { method }),
    };

    return (
      <Form ref={ref} {...formProps}>
        {children}
      </Form>
    );
  }
);

FormComponent.displayName = 'FormComponent';

export default FormComponent;
